<template>
    <header :class="$attrs.class">
        <div class="mx-auto font-inter legacy-md:w-full">
            <div
                class="relative flex items-center justify-between"
                :class="{ 'h-16 border-b border-ds-primary-200': portal === 'employee' }"
            >
                <div class="mx-2 flex-none overflow-hidden legacy-md:w-auto">
                    <a
                        v-if="portal === 'client'"
                        :aria-label="isLoginProcessRoute ? 'Login' : 'Home'"
                        :href="homeLink"
                    >
                        <div class="mx-3 mt-1 w-full py-5 pr-2">
                            <ClosinglockLogo />
                        </div>
                    </a>
                    <a
                        v-else-if="portal === 'customer'"
                        :aria-label="isLoginProcessRoute ? 'Login' : 'Home'"
                        :href="homeLink"
                    >
                        <div class="hidden w-full py-4 pl-3 pr-2 legacy-md:block">
                            <ClosinglockLogo
                                :height="38"
                                :width="152"
                            />
                        </div>
                        <div class="mt-1 w-full py-5 pr-2 legacy-md:hidden">
                            <ClosinglockLogo />
                        </div>
                    </a>
                    <router-link
                        v-else-if="portal === 'employee'"
                        aria-label="Accounts"
                        :to="homeLink"
                    >
                        <ClEmployeeLogo />
                    </router-link>
                </div>
                <slot name="middle"></slot>
                <slot name="navigation"></slot>
            </div>
        </div>
    </header>
    <slot name="warning"></slot>
</template>

<script setup lang="ts">
import ClEmployeeLogo from '@/components/Icons/ClEmployeeLogo.vue';
import ClosinglockLogo from '@/components/Icons/ClosinglockLogo.vue';
import { computed } from 'vue';

export interface ClosinglockHeaderProps {
    isLoginProcessRoute?: boolean;
    portal?: 'employee' | 'customer' | 'client';
}

const props = withDefaults(defineProps<ClosinglockHeaderProps>(), {
    isLoginProcessRoute: false,
    portal: 'employee',
});

defineSlots<{
    csrfField(): void;
    warning(): void;
    navigation(): void;
    middle(): void;
}>();

const homeLink = computed(() => {
    if (props.portal === 'client') {
        return props.isLoginProcessRoute ? '/login' : '/client/home';
    }
    if (props.portal === 'customer') {
        return props.isLoginProcessRoute ? '/login' : '/user/home';
    }
    return '/accounts';
});
</script>
